// removed by extract-text-webpack-plugin
module.exports = {"container":"FacebookSharingDirective-hashed__container__1YLD0","content":"FacebookSharingDirective-hashed__content__wPod0","button":"FacebookSharingDirective-hashed__button__MQIFj","logo":"FacebookSharingDirective-hashed__logo__2e-qw","verb":"FacebookSharingDirective-hashed__verb__2TFIB"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/facebook/FacebookSharingDirective-hashed.scss
// module id = 1203
// module chunks = 0